import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"

// The Assessment of a Company Run whose Compilation wrote no File of its own
// (assessed or no change): its Score Breakdown and selected Detections,
// rescored on demand from the Compilation's frozen inputs.
export const loadCompilationAssessment = createServerFn({ method: "GET" })
  .inputValidator(z.object({ companyRunId: z.string().uuid() }).strict())
  .handler(async ({ data }) => {
    const [{ assertAdminContext }, { readCompilationAssessment }] =
      await Promise.all([
        import("@/lib/supabase/auth"),
        import("@/admin/monitoring/compilation-assessment"),
      ])
    // A server function is directly callable, so the route guard is not enough.
    await assertAdminContext()
    return readCompilationAssessment(data.companyRunId)
  })

export type CompilationAssessment = Awaited<
  ReturnType<typeof loadCompilationAssessment>
>
